export enum Role {
  Host = 'HOST',
  Attendant = 'ATTENDANT',
}

export enum NotificationMethod {
  Email = 'email',
  Sms = 'sms',
}

export type AppointmentVideoMeeting = {
  id: number;
  roomUuid: string;
  coreSchedulingId: number;
  meetingData: null;
  notificationChannel: string;
  callStartDate: string | null;
  callEndDate: string | null;
  participants: {
    roomId: number;
    participantUuid: string;
    role: Role;
    connectedAt: string | null;
  }[];
};

export type MeetingConnectionData = {
  meeting: AppointmentVideoMeeting;
  userType: Role;
  participants: ParticipantConnectionData[];
};

export type ParticipantConnectionData = {
  connectionUrl: string;
  token: string;
  userType: Role;
  role: Role;
  userUuid: string;
};

export type DeliveryStatus = { success: boolean; error?: string };

export type DeliveryStatusWithMethod = DeliveryStatus & { method: NotificationMethod };

export type ParticipantDeliveryStatus = {
  participantUuid: string;
  methods: DeliveryStatusWithMethod[];
};

export type SendMeetingConnectionLinkResponse = {
  participants: ParticipantDeliveryStatus[];
};
